import type { HttpTransportPort } from '@core/domain/ports/driven/HttpTransportPort.ts';
import { FetchHttpAdapter } from './FetchHttpAdapter.ts';
import { XhrHttpAdapter } from './XhrHttpAdapter.ts';

export type HttpTransportKind = 'fetch' | 'xhr';

/** Strategy factory for the shared HTTP transport (API client vs sync with upload progress). */
export function createHttpTransport(kind: HttpTransportKind = 'xhr'): HttpTransportPort {
  if (kind === 'fetch') {
    return new FetchHttpAdapter();
  }
  return new XhrHttpAdapter();
}
